module.exports = __webpack_public_path__ + "static/media/current-geolocation.724846e4.svg";